import { useEffect } from "react";
import useRememberState from "src/hooks/useRememberState";

function useTheme() {
	const [theme, onChange] = useRememberState("theme", "light");

	const toggle = () => {
		const newTheme = theme === "light" ? "dark" : "light";
		onChange(newTheme);
		setCurrentTheme(newTheme);
	};

	return {
		theme,
		toggle,
	};
}

export function useThemeListener() {
	const [theme] = useRememberState("theme", "light");
	useEffect(() => {
		setCurrentTheme(theme);
	}, [theme]);
}

function setCurrentTheme(theme: "dark" | "light") {
	const root = window.document.documentElement;
	const remove = theme === "dark" ? "light" : "dark";
	root.classList.remove(remove);
	// if (process.env.NODE_ENV === "development") {
	// 	console.group("Theme");
	// 	console.log(`Remove -> ${remove}`);
	// 	console.log("Add -> ", theme);
	// }
	root.classList.add(theme);
	console.groupEnd();
}

export default useTheme;
